import { AlertTost, CustomInput, CustomPhoneInput } from "#components";
import ImagesUrl from "#constants/images.js";
import useGet from "#hooks/useGet.js";
import usePost from "#hooks/usePost.js";
import { AdminLayout } from "#layouts";
import { AdminRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { profileInitialValues } from "#validations/initialValues.js";
import { profileValidationSchema } from "#validations/validationSchema.js";
import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const ProfileScreen = () => {
  const [profileImg, setProfileImg] = useState(null);
  const profileImgRef = useRef(null);
  const nav = useNavigate();
  const { data: profileData, isLoading: isProfileLoading } = useGet(
    ENDPOINTS.GET_PROFILE,
    QUERY_KEYS.GET_PROFILE_QUERY_KEY
  );
  const {
    mutateAsync: editProfileMutateAsync,
    isLoading: isLoadingEditProfile,
  } = usePost(ENDPOINTS.PROFILE_UPDATE, QUERY_KEYS.PROFILE_UPDATE_QUERY_KEY);
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: profileInitialValues,
    validationSchema: profileValidationSchema,
    onSubmit: async (values) => {
      const formData = new FormData();
      formData.append("name", values?.fullName);
      formData.append("image", values?.profileImage);
      try {
        const response = await editProfileMutateAsync(formData);
        nav(AdminRoutePath.DASHBOARD.path);
        AlertTost(response?.message, "success");
      } catch (error) {
        toast.dismiss();
        AlertTost(error?.response?.data?.message, "error");
      }
    },
  });
  const profileImageUpload = (target) => {
    const file = target.files[0];
    if (file) {
      setFieldValue("profileImage", file);
      const previewUrl = URL.createObjectURL(file);
      setProfileImg(previewUrl);
    }
  };

  const handelSelectProfile = () => {
    if (profileImgRef.current) {
      profileImgRef.current.click();
    }
  };
  useEffect(() => {
    setValues(
      {
        emailAddress: profileData?.data?.email,
        fullName: profileData?.data?.name,
        profileImage: profileData?.data?.image,
      },
      setProfileImg(profileData?.data?.image)
    );
  }, [profileData?.data]);
  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <form
                className="detail_card_wrapper profile_card_wrapper"
                onSubmit={handleSubmit}
              >
                <div className="profile-detail-wrapper d-flex justify-content-end align-items-center">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="profile-blk position-relative">
                      <div className="profile_upload">
                        <img
                          src={
                            profileImg ? profileImg : `${ImagesUrl.noProfile}`
                          }
                          alt="Profile"
                        />

                        <input
                          type="file"
                          accept="image/*"
                          className="d-none"
                          ref={profileImgRef} // Use ref here
                          onChange={({ target }) => profileImageUpload(target)} // Handle file change
                        />
                        <label
                          htmlFor="profileUpload"
                          onClick={handelSelectProfile}
                        >
                          <img src={ImagesUrl.addPhoto} alt="add-icon" />{" "}
                          {/* Assuming ImagesUrl is available */}
                        </label>
                      </div>

                      <div className="profile_info">
                        <span className="user_name">Anderson</span>
                        <span className="user_email">anderson@gmail.com</span>
                      </div>
                      {errors.profileImage && touched.profileImage && (
                        <p
                          style={{
                            color: "red",
                            marginBottom: 0,
                            position: "absolute",
                            top: "85px",
                          }}
                        >
                          {errors.profileImage}
                        </p>
                      )}
                    </div>
                    <div className="d-flex gap-3">
                      <button
                        className="secondary-btn py-2 w-auto"
                        type="button"
                        onClick={() => nav(AdminRoutePath.DASHBOARD.path)}
                      >
                        Cancel
                      </button>
                      <button
                        className="primary-btn py-2 w-auto"
                        disabled={isLoadingEditProfile}
                      >
                        {isLoadingEditProfile ? (
                          <ClipLoader size={17} color="#fff" />
                        ) : (
                          "Edit"
                        )}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row g-4">
                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomInput
                        label="Full Name"
                        type="text"
                        placeholder="Enter your Full Name"
                        name="fullName"
                        value={values.fullName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.fullName}
                        touched={touched.fullName}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-inner-div">
                      <CustomInput
                        label="Email Address"
                        type="text"
                        placeholder="Enter your Email Address"
                        name="emailAddress"
                        value={values.emailAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.emailAddress}
                        touched={touched.emailAddress}
                        readOnly={true}
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </AdminLayout>
  );
};

export default ProfileScreen;
